// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.el-header {\n  color: #333;\n  line-height: 60px;\n  height: 30px;\n}\n.el-aside {\n  color: #333;\n  border-right: 1px solid rgb(238, 238, 238);\n}\n", ""]);
// Exports
module.exports = exports;
